import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { LikelihoodLabelMap, LikelihoodValues } from '@app/dp-shared';
export const Props_LikelihoodDropDown = {
    adapter: () => SimpleListAdapter([...LikelihoodValues], likelihood => _jsx(_Fragment, { children: LikelihoodLabelMap[likelihood.item] })),
    placeholder: 'Pick Likelihood',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_Likelihood = TS_DropDown.prepare(Props_LikelihoodDropDown);
//# sourceMappingURL=ui-components.js.map